
import Vue from "vue";
import AppContactSearch from "@/components/contacts/ContactSearchWithBrowseAndCreate.vue";
import AppSaleTypeSelect from "@/components/sales/SaleTypeSelect.vue";
import {SaleEditState} from "@/utils/sale-edit/sale-edit-state";
import {Contact, SaleType} from "@/models/base";

export default Vue.extend({
	data(){
		return {

		};
	},
	props: {
		activeGroupId: Number,
		state: {
			type: Object as () => SaleEditState,
			required: true
		}
	},
	methods: {
		selectContact(c:Contact){
			this.state.selectContact(c);
			this.state.productEditRowState.contactDiscount = c.Discount;
		},
		cancel(){
			this.$emit("close");
		},
		save(){
			this.$emit("close");
		},
		onTypeChange(newType: SaleType){
			this.state.setSaleType(newType);
			this.state.setToPrintMessage(true);
		}
	},
	created(){

	},
	components: {
		AppContactSearch,
		AppSaleTypeSelect
	},
	i18nEx: {
		componentPrefix: "components.sales.Cashier"
	},
});
